import React from 'react';
import spinner from '../../images/spinner.svg';
import "./LoadingSpinner.css"

const LoadingSpinner = props => {
    let spinnerClass = props.blue ? 'spinner blue' : props.grey ? 'spinner grey' : 'spinner';
    return (
        <div className={spinnerClass} data-testid={props.testId} tabIndex="-1">
			<img src={spinner} alt="Spinning animation" height={props.size || 40}/>
		</div>
    );
}

export default LoadingSpinner;